import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import Preview from './Preview';
import { AccountWrapper, LogInWrapper, RegisterWrapper, TitleWrapper } from '../../fieldvision.style';
import { withTheme } from 'styled-components';

import { TYPES } from './index';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
const FieldVisionLoginRegister = React.lazy(() => import(/* webpackChunkName: "fieldVisionLoginRegister" */ './FieldVisionLoginRegister'));

const Entry = ({
    onLoginSuccess,
    onLoginError,
    componentType,
    setComponentType
}) => {
    const loginTitle = useTranslator('fieldpass_login_title', 'Log In');
    const registerTitle = useTranslator('fieldpass_register_title', 'Register');

    return (
        <>
            { componentType === TYPES.PREVIEW && <Preview setAccountType={setComponentType} /> }
            <AccountWrapper $type={componentType}>
                <LogInWrapper $type={componentType}>
                    <TitleWrapper>{ loginTitle }</TitleWrapper>
                    <Suspense fallback={<></>}>
                        <FieldVisionLoginRegister componentType={TYPES.LOGIN} setAccountType={setComponentType} onSuccess={onLoginSuccess} onError={onLoginError} />
                    </Suspense>
                </LogInWrapper>
                { componentType === TYPES.REGISTER &&
                        <RegisterWrapper>
                            <TitleWrapper>{ registerTitle }</TitleWrapper>
                            <Suspense fallback={<></>}>
                                <FieldVisionLoginRegister componentType={TYPES.REGISTER} setAccountType={setComponentType} onSuccess={onLoginSuccess} onError={onLoginError} />
                            </Suspense>
                        </RegisterWrapper>
                }
            </AccountWrapper>
        </>
    );
};

Entry.propTypes = {
    onLoginSuccess: PropTypes.func,
    onLoginError: PropTypes.func,
    componentType: PropTypes.string,
    setComponentType: PropTypes.func
};

export default withTheme(Entry);
